import { Col, Container, Row } from "react-bootstrap"

const PrivacyPolicy = () => {
    return (
        <div className="padding-top padding-bottom">
            <Container>
                <Row>
                    <Col>
                    <h2 className="heading2">Privacy Policy</h2>
                    </Col>
                </Row>
            </Container>
        </div>
        
    )
}

export default PrivacyPolicy